import React from "react";
// Shared global classes (.signature-container, .success, ...) still live here.
import "./ViewSignatureSamplePopup.scss";
import rightSignatureSample from "../../../assets/right-signature-sample.jpg";
import wrongSignatureOne from "../../../assets/wrong-signature-one.jpg";
import wrongSignatureTwo from "../../../assets/wrong-signature-two-new.jpg";
import wrongSignatureThree from "../../../assets/wrong-signature-three.jpg";
import GuideModal, { GuideGrid } from "../../UI/GuideModal/GuideModal";

export interface IViewSignatureSamplePopupProps {
  setShowPopup: Function;
  showPopup: boolean;
  position?: any;
  parentClassName?: string;
  titleId?: string;
}

const ViewSignatureSamplePopup = (props: IViewSignatureSamplePopupProps) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };

  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Guide for Signature Upload"
      titleId={props.titleId || "sample-popup-title"}
      closeLabel="Close signature guide"
    >
      <GuideGrid
        items={[
          { src: rightSignatureSample, alt: "Example of a valid clear signature", caption: "Use a clear background.", valid: true },
          { src: wrongSignatureOne, alt: "Invalid signature on ruled background", caption: "Don't use a ruled background." },
          { src: wrongSignatureTwo, alt: "Invalid signature with light stroke", caption: "Don't use a light stroke." },
          { src: wrongSignatureThree, alt: "Invalid signature with thick stroke", caption: "Don't use a thick stroke." },
        ]}
      />
    </GuideModal>
  );
};
export default ViewSignatureSamplePopup;
